export default __webpack_public_path__ + "static/media/Hair_preview.ea03417c.gif";